import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import ArticleCard from "../blog/ArticleCard";
import { api } from "../../api";

export default function LatestPosts() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { limit: 3 } }).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">From the blog</p>
            <h2 className="mt-3 font-display text-[30px] lg:text-[42px] leading-[1.1] text-foreground">Latest insights</h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm font-medium text-[#2ED9B8] hover:gap-2 transition-all">
            View all articles <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {items.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 60}><ArticleCard article={a} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
